<div *ngIf="isShowList" class="es-list-page h-100">
  <ng-container *ngIf="isShowFilters">
    <ng-template #filterTabs>
      <div class="es-list-filters-tabs">
        <div class="es-list-filters-tabs-item" (click)="selectTab(enumEntrySummaryStatusTab.ALL)">
          <span class="es-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumEntrySummaryStatusTab.ALL }">
            {{ "LABELS.ALL" | translate }}
          </span>
        </div>

        <div class="es-list-filters-tabs-item" (click)="selectTab(enumEntrySummaryStatusTab.DRAFTS)">
          <span class="es-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumEntrySummaryStatusTab.DRAFTS }">
            {{ "LABELS.DRAFTS" | translate }}
          </span>
          <span class="es-list-filters-tabs-item-count">({{ draftsCount }})</span>
        </div>

        <div class="es-list-filters-tabs-item" (click)="selectTab(enumEntrySummaryStatusTab.PROCESSING)">
          <span class="es-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumEntrySummaryStatusTab.PROCESSING }">
            {{ "LABELS.PROCESSING" | translate }}
          </span>
          <span class="es-list-filters-tabs-item-count">({{ processingCount }})</span>
        </div>

        <div class="es-list-filters-tabs-item" (click)="selectTab(enumEntrySummaryStatusTab.RELEASED)">
          <span class="es-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumEntrySummaryStatusTab.RELEASED }">
            {{ "LABELS.RELEASED" | translate }}
          </span>
          <span class="es-list-filters-tabs-item-count">({{ releasedCount }})</span>
        </div>
      </div>
    </ng-template>

    <ng-template #searchForm let-isMobile>
      <div class="es-list-filters-search-input">
        <form (ngSubmit)="searchUpdated(searchParameterCtrl.value)">
          <input type="text" [formControl]="searchParameterCtrl" [placeholder]="'LABELS.ISF_SEARCH_PLACEHOLDER' | translate" />

          <button type="button" class="es-list-filters-search-input-close" *ngIf="!!searchParameterCtrl.value" (click)="resetSearch()">
            <img alt="remove" src="/assets/icons/icon_close_gray.svg" />
          </button>

          <button type="submit" class="es-list-filters-search-input-submit">
            <img alt="search" [src]="isMobile ? '/assets/icons/icon_search_gray.svg' : '/assets/icons/icon_search.svg'" />
          </button>
        </form>
      </div>
    </ng-template>

    <div class="row d-none d-lg-flex mb-4">
      <div class="col-12">
        <div class="es-list-filters d-none d-lg-flex">
          <ng-container *ngTemplateOutlet="filterTabs"></ng-container>

          <div class="es-list-filters-search">
            <ng-container *ngTemplateOutlet="searchForm; context: { $implicit: false }"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="es-list-filters-mobile d-lg-none">
      <ng-container *ngTemplateOutlet="filterTabs"></ng-container>
      <ng-container *ngTemplateOutlet="searchForm; context: { $implicit: true }"></ng-container>
    </div>
  </ng-container>

  <div class="es-list-header mx-3" *ngIf="isShowHeader">
    <span>
      {{ "PAGE.ES_LIST.HEADER" | translate }}
      <ng-container *ngIf="paginatedList.items.length">({{ paginatedList.items.length + "/" + paginatedList.total }})</ng-container>
    </span>
    <div class="d-sm-inline d-flex justify-content-end pr-2">
      <button *ngIf="showButtonShowMore" type="button" class="btn btn-link btn-sm ml-2" (click)="onShowMore()">
        {{ "BUTTON.SHOW_MORE" | translate }}
      </button>
      <button type="button" class="btn btn-link btn-sm ml-2" (click)="refreshEntrySummaries()">{{ "BUTTON.REFRESH" | translate }}</button>
    </div>
  </div>
  <ng-container *ngIf="esList.length; else emptyList">
    <div class="row col title-row flex-lg-nowrap align-items-center" [style.padding]="'0 0 0 110px'">
      <div class="es-title-display-part">
        <div class="es-title es-title-name">{{ "LABELS.REFERENCE_NUMBERS" | translate }}</div>
        <div class="es-title es-title-from-to">{{ "LABELS.FROM" | translate }} - {{ "LABELS.TO" | translate }}</div>
        <div class="es-title es-title-arrival-date">{{ "LABELS.ARRIVAL_DATE" | translate }}</div>
        <div class="es-title es-title-calculations flex-column">
          <div>{{ "LABELS.GOODS_VALUE" | translate }}</div>
          <div>
            {{ "LABELS.DUTIES_AND_FEES" | translate }}
          </div>
        </div>
        <div class="es-title es-title-status">{{ "LABELS.STATUS" | translate }}</div>
      </div>
      <div class="es-title es-title-actions" [ngClass]="{ 'has-broker-chat': hasBrokerChat }">{{ "LABELS.ACTIONS" | translate }}</div>
    </div>
    <div
      class="d-none d-xl-block"
      *ngIf="isShowBatchNotificationSuccess || isShowBatchNotificationPartial || isShowBatchNotificationPending"
    >
      <batch-send-success-notification
        header="EXCELLENT"
        [hint]="paymentCountStr | translate : { count: payedBatchItems.length }"
        *ngIf="isShowBatchNotificationSuccess"
      ></batch-send-success-notification>

      <batch-process-partial-list-notification
        [batchItem]="batchItem"
        [payedBatchItems]="payedBatchItems.length"
        *ngIf="isShowBatchNotificationPartial"
      ></batch-process-partial-list-notification>

      <batch-send-pending-list-notification
        header="EXCELLENT"
        [hint]="paymentPendingCountStr | translate : { count: pendingBatchItems.length }"
        *ngIf="isShowBatchNotificationPending"
      ></batch-send-pending-list-notification>
    </div>
    <div>
      <pagination-scrolling
        [list]="esList"
        [itemTemplate]="esDetailsTemplate"
        [scrollContentClass]="scrollContentClass"
        (loadNew)="loadNewOnScroll ? getNextEntrySummaries(false) : null"
      ></pagination-scrolling>
    </div>
    <ng-template #esDetailsTemplate let-es="item" let-lastShown="lastShown">
      <es-list-detail
        [es]="es"
        [lastShown]="lastShown"
        (update)="refreshEntrySummaries()"
        (editInternalNotes)="onEditInternalNotes(es)"
        (openChat)="onOpenChat(es.referenceNumber)"
      ></es-list-detail>
    </ng-template>
  </ng-container>
  <ng-template #emptyList>
    <div class="empty-es-list">
      <div>{{ "LABELS.EMPTY_LIST" | translate }}</div>
      <div class="card-action mt-3">
        <a class="btn btn-primary m-0" routerLink="/entry-summary/start">
          <div class="border-block">
            <span class="icon-ic_plus"></span>
          </div>
          <div class="text-block">{{ "LABELS.CREATE_YOUR_ES" | translate }}</div>
        </a>
      </div>
    </div>
  </ng-template>
</div>
